export default __webpack_public_path__ + "static/media/coal.83ad3353.png";